import React from 'react'
import { List, Steps } from 'antd';
import { type IAdvertise } from '../../../../store/slices/advertisesSlice'
import { type Unit } from '../../../../store/slices/unitsSlice'
import StepComponent from '../offerTimelines/StepComponent'

interface IProps {
    advertise: IAdvertise
    unit: Unit
}

export default function GroupTimelineAdvertise({ advertise, unit }: IProps): JSX.Element {
    let process = 0
    const unitStatuses = unit.attributes.Statuses
    const advertiseStatuses = advertise?.attributes?.Statuses
    const typeUnit = unit.attributes?.Marketing?.Use

    let daysLeft = 0
    if (advertise.attributes.EndDate) {
        const vacantDate = new Date(advertise.attributes.EndDate);
        vacantDate.setDate(vacantDate.getDate() + 1);
        const timeDiff = vacantDate.getTime() - new Date().getTime();
        daysLeft = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
    }

    let titleLoadUnitDocs = 'Upload unit documents'
    let descriptionLoadUnitDocs = 'Unit documents have been sent to your registered email and feel free to download them.'


    let titleAdvForm = 'Please send A-Form to BSO'
    let descriptionAdvForm = 'Our manager should approve that form'


    let titleTrakheesi = typeUnit !== 'For rent' ? 'A-Form approved! Add advertisements Trakheesi IDs' : 'Add advertisements Trakheesi IDs'
    let descriptionTrakheesi = 'Please provide the Trakheesi IDs to advertisements that you are doing for this unit'



    let titleActive = daysLeft > 0 ? 'Your advertisements is active.' + ` You have ${daysLeft} days, before it will be over` : 'Your advertisements is inactive.'
    let descriptionActive = 'Feel free to make your advertisement. After the advertisement ends please delete inactive/expired advertising Trakheesi IDs and published posts'

    let titleClosure = 'Advertisement completed successfully'
    let descriptionClosure = 'Congratulations on another completed advertisement! Let’s make a new one with the BSO Club!'


    if (advertiseStatuses?.includes('In-process')) {
        process = 0
    } else if (advertiseStatuses?.includes('Docs received')) {
        titleLoadUnitDocs = 'Units documents received'
        descriptionLoadUnitDocs = "You can download anytime"
        if (typeUnit !== 'For rent') {
            process = 1
        }
    } else if (advertiseStatuses?.includes('A Form added')) {
        process = 1
        titleLoadUnitDocs = 'A-Form sent'
        titleAdvForm = 'Wait for A-Form approval'
        descriptionAdvForm = 'Our specialist will approve your uploaded A-Form as soon as possible'
    } else if (advertiseStatuses?.includes('A Form rejected')) {
        titleAdvForm = 'Your uploaded A-Form was rejected by BSO'
        descriptionAdvForm = 'Unfortunately, our specialist has decided to reject your uploaded A-Form. Please fix all issues and resubmit the form'
        process = 1
    }


    const groupDocsProcessing = [
        {
            title: <StepComponent
                title={titleLoadUnitDocs}
                process={0}
                currentProcess={process}
                description={descriptionLoadUnitDocs}
                statuses={advertiseStatuses}
            />
        }
        , ...(typeUnit === 'For sale' ? [{
            title: <StepComponent
                title={titleAdvForm}
                process={1}
                currentProcess={process}
                description={descriptionAdvForm}
                statuses={advertiseStatuses}
                rejectReason={advertise?.attributes?.RejectReason ?? undefined}
            />
        }] : [])
    ]

    if (advertiseStatuses?.includes('Confirmed')) {
        // just default description 
    } else if (advertiseStatuses?.includes('Links added')) {
        titleTrakheesi = 'Wait for advertisements Trakheesi IDs approval'
        descriptionTrakheesi = 'Our specialist will approve your advertisements Trakheesi IDs soon. You also can provide new Trakheesi IDs during this process that have been created by you recently and are not in the submitted list'
    } else if (advertiseStatuses?.includes('Links rejected')) {
        titleTrakheesi = 'Your advertisements Trakheesi IDs was rejected by BSO.'
        descriptionTrakheesi = 'Please review your Trakheesi IDs and resubmit the right one'


    } else if (advertiseStatuses?.includes('Links approved')) {
        process = 1
        titleTrakheesi = 'Your advertisements Trakheesi ID\'s were approved by BSO'
    } else if (advertiseStatuses?.includes('Advertisement closed')) {
        process = 1
        titleTrakheesi = 'Your advertisements Trakheesi ID\'s were approved by BSO'
        titleActive = 'Your advertisement is over'
        descriptionActive = 'Please remove all ads that you submitted to 3-party advertisement platforms and submit this advertisement to final checks through the app'
    } else if (advertiseStatuses?.includes('Ads removing rejected')) {
        process = 1
        titleTrakheesi = 'Advertisement ended'
        titleActive = 'Request rejected, active ads found.'
        descriptionActive = 'We found active ads for this unit. Please delete and resubmit your request'
    } else if (advertiseStatuses?.includes('Ads removed')) {
        process = 1
        titleTrakheesi = 'Advertisement ended'
        titleActive = 'Your advertisement successfully passed the final checks'
        descriptionActive = 'Feel free to close this advertisement'
    }

    const groupAdvertisementReview = [
        {
            title: <StepComponent
                title={titleTrakheesi}
                process={0}
                currentProcess={process}
                description={descriptionTrakheesi}
                statuses={advertiseStatuses}
                rejectReason={advertise?.attributes?.RejectReason ?? undefined}
            />
        },
        ...(process > 0 ? [
            {
                title: <StepComponent
                    title={titleActive}
                    process={1}
                    currentProcess={process}
                    description={descriptionActive}
                    statuses={advertiseStatuses}
                    rejectReason={advertise?.attributes?.RejectReason ?? undefined}
                />
            }
        ] : [])
    ];



    if (advertiseStatuses?.includes('Completed')) {
        // default block
    } else if (advertiseStatuses?.includes('Canceled')) {
        titleClosure = typeUnit === 'For rent' ? 'This unit has been rented' : 'This unit has been sold'
        descriptionClosure = ''
    }
    //  else {
    //     process = 0
    //     //  textProcessFirst = 'Your advertise during the process'
    // }

    const groupClosure = [
        {
            title: <StepComponent
                title={titleClosure}
                process={0}
                currentProcess={process}
                description={descriptionClosure}
                statuses={advertiseStatuses}
            />,
            status: 'finish',
        }
    ]


    const data = [
        {
            // Подготовка документов и подтверждение формы
            title: 'Document Processing',
            status: undefined,
            icon: <i className="ki-duotone ki-loading fs-5x">
                <span className="path1"></span>
                <span className="path2"></span>
            </i>,
            iconProcess: <i className="ki-duotone ki-loading fs-5x text-success">
                <span className="path1"></span>
                <span className="path2"></span>
            </i>,
            description: 'Processing the required documents and form submissions.',
            statuses: ['In-process', typeUnit !== 'For sale' ? '' : 'Docs received', 'A Form added', 'A Form rejected'],
            items: groupDocsProcessing
        },
        {
            // Объявление и его подтверждение
            title: 'Advertisement Review & Active',
            status: undefined,
            icon: <i className="ki-duotone ki-time fs-5x">
                <span className="path1"></span>
                <span className="path2"></span>
            </i>,
            iconProcess: <i className="ki-duotone ki-time fs-5x text-success">
                <span className="path1"></span>
                <span className="path2"></span>
            </i>,
            description: 'Review and approval process of the advertisement.',
            statuses: [typeUnit === 'For sale' ? '' : 'Docs received', 'Links added', 'Links rejected', 'Links approved', 'Ads removing rejected', 'Ads removed', 'Confirmed', 'Advertisement closed'],
            items: groupAdvertisementReview
        },
        // add active step
        // {
        //     // Объявление и его подтверждение
        //     title: 'Active & Review',
        //     status: undefined,
        //     icon: <i className="ki-duotone ki-time fs-5x">
        //         <span className="path1"></span>
        //         <span className="path2"></span>
        //     </i>,
        //     iconProcess: <i className="ki-duotone ki-time fs-5x text-success">
        //         <span className="path1"></span>
        //         <span className="path2"></span>
        //     </i>,
        //     description: 'Review and approval process of the advertisement.',
        //     statuses: ['Links approved', 'Ads removing rejected', 'Ads removed'],
        //     items: groupAdvertisementReview
        // },
        {
            // Закрытие объявления
            title: 'Advertisement Closure',
            status: undefined,
            icon: <i className="ki-duotone ki-check fs-5x"></i>,
            iconProcess: <i className="ki-duotone ki-check fs-5x text-success"></i>,
            description: 'Final stage where the advertisement is closed or removed.',
            statuses: ['Completed', 'Canceled'],
            items: groupClosure
        }
    ];


    const activeStepIndex = data.findIndex(step =>
        step.statuses.includes(advertiseStatuses[0])
    );
    return (
        <div className='my-4 pt-2' style={{ maxWidth: '450px', width: '100%' }}>
            <List
                itemLayout="horizontal"
                dataSource={data}
                renderItem={(group, index) => {
                    const isActive = index === activeStepIndex;
                    const currentProcess = process;
                    return (
                        <div className='d-flex flex-column'>
                            <List.Item >
                                <div className='d-flex flex-column w-100'>
                                    <List.Item.Meta
                                        style={{
                                            lineHeight: 0.1
                                        }}
                                        avatar={
                                            <div className={`d-flex align-items-center justify-content-center w-100`}>
                                                {isActive ?
                                                    advertiseStatuses[0].includes("Completed") ?
                                                        <span className={'border border-2 align-middle p-7 position-relative border-success  rounded rounded-circle'}>
                                                        </span> : advertiseStatuses[0].includes("Canceled") ?
                                                            <span className={'border border-2 align-middle p-7 position-relative border-danger  rounded rounded-circle'}>
                                                            </span> :
                                                            < span className={'spinner-border spinner-border-sm align-middle p-7 position-relative text-success'}>
                                                            </span>
                                                    : null}
                                                <span className={`position-${isActive ? 'absolute' : 'static'}`}>
                                                    {isActive ? advertiseStatuses[0].includes("Canceled") ? <i className="ki-duotone ki-cross-circle fs-5x text-danger">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i> : group.iconProcess : group.icon}
                                                </span>
                                            </div>
                                        }
                                        title={<div className='lh-1'><span className='lh-1 fs-4'>{group.title.toUpperCase()}</span></div>}
                                        description={<div className='lh-1'><span className='lh-1 fs-7'>{group.description}</span></div>}
                                    />
                                    <div className='ps-4 ms-4 mt-2'>
                                        {isActive &&
                                            <>
                                                <Steps
                                                    className='w-100'
                                                    style={{ marginTop: 8, width: '100%' }}
                                                    current={currentProcess}
                                                    status={undefined}
                                                    items={group.items}
                                                />

                                            </>
                                        }
                                    </div>
                                </div>
                            </List.Item>
                        </div>
                    )
                }}
            />
        </div>
    )
}
